<template>
  <div>
    <ts-dialog title="Share your file request" :visible.sync="visible" width="500px" center>
      <div class="flex items-center justify-center mb-2">
        <div class="row">
          <p class="font-semibold" v-text="url"></p>
        </div>
        <div class="actions">
          <ts-button size="small" circle @click="copy()">
            <ts-icon icon="link" size="x-small" color="#6d7587" />
          </ts-button>
        </div>
      </div>
      <div class="flex mb-2 items-center">
        <ts-divider></ts-divider>
        <p class="flex-none px-2 font-semibold">Or send it by email</p>
        <ts-divider></ts-divider>
      </div>
      <div>
        <ts-form-item label="Email to" :validation="$v.form.email">
          <ts-input placeholder="Email address" v-model.lazy="$v.form.email.$model"></ts-input>
        </ts-form-item>
        <!-- <ts-form-item label="Add a message (optional)" :validation="$v.form.message">
          <ts-input type="textarea" :rows="4" placeholder="" v-model.lazy="$v.form.message.$model"></ts-input>
        </ts-form-item> -->
      </div>
      <div slot="footer" class="flex items-center justify-end">
        <!-- <div class="uppercase cursor-pointer">
          <span class="px-2 py-2 uppercase cursor-pointer" @click="skip"> skip this step </span>
        </div> -->
        <div class="font-semibold">
          <ts-button class="font-semibold" :loading="loading" @click="handleSaveClick">Send email</ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button ref="shareButton" type="primary" size="small" filled @click="handleOpenDialogButtonClick">
      Share
    </ts-button>
  </div>
</template>

<script>
import { shareFileRequestByMail } from '@/api/workflow';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        email: '',
        message: ''
      }
    };
  },
  mounted() {
    if (this.value.shouldOpen) {
      this.$refs['shareButton'].$el.querySelector('button').click();
      this.$store.commit('workflow/fileRequests/setFileRequest', {
        ...this.value,
        shouldOpen: false
      });
    }
  },
  validations: {
    form: {
      email: {
        required
      },
      message: {}
    }
  },
  methods: {
    copy() {
      this.$emit('copy');
    },
    handleOpenDialogButtonClick() {
      this.visible = true;
    },
    resetForm() {
      this.form = {
        email: '',
        message: ''
      };

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    async handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // this.$emit('input', this.form);
        this.loading = true;
        try {
          await shareFileRequestByMail({
            token: this.value.token,
            ...this.form
          });
        } catch (error) {
          this.loading = false;
        }
        this.loading = false;
        this.visible = false;
        this.resetForm();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.justify-end {
  justify-content: flex-end;
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
</style>